<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-grid">
        <!-- Quick Links -->
        <div class="footer-column">
          <h3 class="footer-title">Otkrij više</h3>
          <ul class="footer-links">
            <li>
              <router-link to="/about" class="footer-link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
                O nama
              </router-link>
            </li>
            <li>
              <router-link to="/prijave" class="footer-link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
                Škola šaha
              </router-link>
            </li>
            <li>
              <router-link to="/ourteam" class="footer-link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
                Naš tim
              </router-link>
            </li>
            <li>
              <router-link to="/kontakt" class="footer-link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
                Kontakt
              </router-link>
            </li>
          </ul>
        </div>

        <!-- YouTube Video -->
        <div class="footer-column video-column">
          <h3 class="footer-title">Pogledaj nas na YouTube-u</h3>
          <div class="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/EINSGZVBw3U?si=T_uHSMHp5IsYgRJm"
              title="ŠK Batana YouTube video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <!-- Contact Info -->
        <div class="footer-column">
          <h3 class="footer-title">Kontakt</h3>
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div class="contact-text">
                <p>Pekarska 6</p>
                <p>52210, Rovinj</p>
              </div>
            </div>

            <div class="contact-item">
              <div class="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div class="contact-text">
                <a :href="'mailto:' + $store.state.mailKluba" class="email-link">
                  {{ $store.state.mailKluba }}
                </a>
              </div>
            </div>

            <div class="social-links">
              <a 
                href="https://www.facebook.com/SahovskiKlubBatana/" 
                target="_blank" 
                rel="noopener noreferrer"
                class="social-icon facebook"
                aria-label="Facebook"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a 
                href="https://www.youtube.com/@sahovskiklubbatana5767" 
                target="_blank" 
                rel="noopener noreferrer"
                class="social-icon youtube"
                aria-label="YouTube"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Šahovski klub Batana. Sva prava pridržana.
        </p>
        <div class="footer-badge">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
          <span>Napravljeno s ljubavlju prema šahu</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterPage",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
/* Site Footer */
.site-footer {
  background: linear-gradient(135deg, #1a1a2e 0%, #2d3748 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.site-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="rgba(102, 126, 234, 0.03)" width="10" height="10" x="0" y="0"/><rect fill="rgba(102, 126, 234, 0.03)" width="10" height="10" x="20" y="20"/><rect fill="rgba(102, 126, 234, 0.03)" width="10" height="10" x="40" y="40"/><rect fill="rgba(102, 126, 234, 0.03)" width="10" height="10" x="60" y="60"/><rect fill="rgba(102, 126, 234, 0.03)" width="10" height="10" x="80" y="80"/></svg>');
  opacity: 0.5;
}

/* Footer Content */
.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 20px 60px;
  position: relative;
  z-index: 1;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
}

/* Footer Column */
.footer-column {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.footer-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  margin: 0 0 10px 0;
  position: relative;
  padding-bottom: 15px;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px;
}

/* Footer Links */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.3s ease;
  padding: 8px 0;
}

.footer-link svg {
  width: 16px;
  height: 16px;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
}

.footer-link:hover {
  color: white;
  padding-left: 10px;
}

.footer-link:hover svg {
  opacity: 1;
  transform: translateX(0);
}

/* Video Column */
.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  background: #000;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* Contact Info */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-item {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.contact-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: rgba(102, 126, 234, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-icon svg {
  width: 20px;
  height: 20px;
  color: #667eea;
}

.contact-text {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contact-text p {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9375rem;
  line-height: 1.6;
}

.email-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.email-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* Social Links */
.social-links {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.social-icon {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon svg {
  width: 22px;
  height: 22px;
  color: white;
}

.social-icon.facebook:hover {
  background: #1877f2;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(24, 119, 242, 0.4);
}

.social-icon.youtube:hover {
  background: #ff0000;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);
}

/* Footer Bottom */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 30px 20px;
  position: relative;
  z-index: 1;
}

.footer-bottom-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.copyright {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
}

.footer-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
}

.footer-badge svg {
  width: 16px;
  height: 16px;
  color: #667eea;
  animation: heartbeat 1.5s ease-in-out infinite;
}

.footer-badge span {
  font-weight: 500;
}

/* Animations */
@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
  }

  .video-column {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .footer-content {
    padding: 60px 20px 40px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .video-column {
    grid-column: auto;
  }

  .footer-title {
    font-size: 1.375rem;
  }

  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .footer-badge {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-content {
    padding: 50px 15px 30px;
  }

  .footer-grid {
    gap: 35px;
  }

  .footer-title {
    font-size: 1.25rem;
  }

  .footer-link {
    font-size: 0.9375rem;
  }

  .contact-icon {
    width: 36px;
    height: 36px;
  }

  .contact-icon svg {
    width: 18px;
    height: 18px;
  }

  .social-icon {
    width: 42px;
    height: 42px;
  }

  .social-icon svg {
    width: 20px;
    height: 20px;
  }

  .copyright,
  .footer-badge {
    font-size: 0.8125rem;
  }
}
</style>